export const SYSTEM_DESIGN_DUMMY_ID = "dummy";

export const ALGORITHM_ID = "dummy";
